import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import { orderStatus } from 'utils/app-configs';
import { FormItem, FormText } from 'ui';
import styled from 'styled-components';
// eslint-disable-next-line
import ReferenceDataDropdown from 'common/reference-data/containers/reference-data-dropdown-container';
import { injectIntl } from 'react-intl';

const FseRow = styled(Row)`
  margin-right: 0;
  margin-bottom: 35px;
`;

const FieldEngineerDropdown = ({
  engineer,
  preferredEngineer,
  lastVisitEngineer,
  defaultEngineer,
  activeStatus,
  form: {
    getFieldDecorator,
    setFieldsValue,
  },
  disabled,
  groups,
  intl,
  transformValues,
  recommendedEngineers = [],
}) => {
  const onEngineerChange = (v) => {
    setFieldsValue({
      technicianNumber: v?.number,
      technicianName: v?.name,
    });
  };

  // Edit of engineer is allowed until & incl. released
  const canEditEngineer = activeStatus && activeStatus.id <= orderStatus.planned;

  const engineerNumberValidator = getFieldDecorator('technicianNumber', {
    initialValue: engineer?.number,
    rules: [{ required: true, message: intl.formatMessage({ id: 'rules.FIELD_ENGINEER' }) }],
  });

  getFieldDecorator('technicianName', {
    initialValue: engineer?.name,
  });

  return (
    <FseRow type='flex' gutter={16}>
      <Col md={6} sm={24} xs={24} data-test-id='field-engineer'>
        <FormItem
          label={intl.formatMessage({ id: 'order.fieldEngineer.FIELD_SERVICE_ENGINEER' })}
          colon={false}
        >
          {canEditEngineer ?
            engineerNumberValidator(
              <ReferenceDataDropdown
                width='300px'
                isSorted={true}
                groups={groups}
                isGrouped={true}
                disabled={disabled}
                placeholder={intl.formatMessage({ id: 'order.groupDropdown.DROPDOWN_DEFAULT' })}
                type='order'
                name='workCenters'
                valueKey='number'
                valueLabel='name'
                onObjectChanged={onEngineerChange}
                firstOption={defaultEngineer && defaultEngineer.number}
                transformValues={transformValues}
                notFoundLabel={
                  `${engineer?.name} [${intl.formatMessage({ id: 'common.INACTIVE' })}]`
                }
              />,
            )
            :
            <FormText>{engineer && engineer.name}</FormText>
          }
        </FormItem>
      </Col>
      <Col md={4} sm={24} xs={24}>
        <FormItem
          label={intl.formatMessage({ id: 'order.fieldEngineer.PREFERRED_ENGINEER' })}
          colon={false}
        >
          {preferredEngineer && preferredEngineer.name &&
            <FormText>{preferredEngineer.name}</FormText>
          }
        </FormItem>
      </Col>
      <Col md={4} sm={24} xs={24}>
        <FormItem
          label={intl.formatMessage({ id: 'order.fieldEngineer.LAST_VISIT_ENGINEER' })}
          colon={false}
        >
          {lastVisitEngineer && lastVisitEngineer.name &&
            <FormText>{lastVisitEngineer.name}</FormText>
          }
        </FormItem>
      </Col>
      {recommendedEngineers?.length ?
        <Col md={10} sm={24} xs={24}>
          <FormItem
            label={intl.formatMessage({ id: 'order.fieldEngineer.RECOMMENDED_TECHNICIAN' })}
          >
            <Row type='flex' gutter={16}>
              {recommendedEngineers
                .sort((a, b) => a.priority - b.priority)
                .map(re =>
                  <Col key={re.number} md={8} sm={24} xs={24}>
                    <FormText>{re.name}</FormText>
                  </Col>,
                )}
            </Row>
          </FormItem>
        </Col> :
        null}
    </FseRow>
  );
};

FieldEngineerDropdown.propTypes = {
  engineer: PropTypes.object,
  preferredEngineer: PropTypes.object,
  lastVisitEngineer: PropTypes.object,
  defaultEngineer: PropTypes.object,
  activeStatus: PropTypes.object,
  form: PropTypes.object,
  disabled: PropTypes.bool,
  groups: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    filter: PropTypes.func.isRequired,
  })),
  intl: PropTypes.object,
  transformValues: PropTypes.func,
  recommendedEngineers: PropTypes.array,
};

export default injectIntl(FieldEngineerDropdown);
